import { __extends } from "tslib";
import 'javascript-detect-element-resize';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';
import { noop } from 'lodash-es';
import { Orientation } from '@marvelapp/core';
import resizeRootId from '../constants/resizeRootId';
import styles from './Device.module.css';
var Device = /** @class */ (function (_super) {
    __extends(Device, _super);
    function Device() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.updateDeviceDimensions = function () {
            var MARGIN_PCT = 0.02;
            var _a = _this.props, onScreenResize = _a.onScreenResize, dimensions = _a.dimensions;
            var width = dimensions.width, height = dimensions.height, padding = dimensions.padding, borderRadius = dimensions.borderRadius;
            var rootWidth = _this._root.offsetWidth;
            var rootHeight = _this._root.offsetHeight;
            if (rootWidth === 0 || rootHeight === 0)
                return;
            var deviceOuterWidth = width + padding[1] + padding[3];
            var deviceOuterHeight = height + padding[0] + padding[2];
            var scaleRatio = 1;
            if (_this.isFullScreen()) {
                // Full screen mode
                width = rootWidth;
                height = rootHeight;
                padding = [0, 0, 0, 0];
            }
            else if (rootHeight < deviceOuterHeight || rootWidth < deviceOuterWidth) {
                // Responsive mode
                scaleRatio =
                    Math.min(rootWidth / deviceOuterWidth, rootHeight / deviceOuterHeight) -
                        MARGIN_PCT;
                width *= scaleRatio;
                height *= scaleRatio;
                padding = padding.map(function (p) { return p * scaleRatio; });
            }
            if (borderRadius) {
                borderRadius *= scaleRatio;
            }
            onScreenResize({
                width: width,
                height: height,
                padding: padding,
            });
            _this.setState({
                width: width,
                height: height,
                padding: padding,
                borderRadius: borderRadius,
            });
        };
        return _this;
    }
    Device.prototype.componentDidMount = function () {
        this._root = document.getElementById(resizeRootId);
        if (!this._root) {
            if (process.env.NODE_ENV === 'test') {
                // This might happen in karma when using shallow rendering
                this._root = document.body;
            }
            else {
                throw new Error('Cannot find Prototype root node');
            }
        }
        this.updateDeviceDimensions();
        window.addResizeListener(this._root, this.updateDeviceDimensions);
    };
    Device.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var keys = [
            'orientation',
            'frame',
            'isMobile',
            'isWeb',
            'isInHandoffMode',
        ];
        var updateDimensions = keys.some(function (key) { return _this.props[key] !== prevProps[key]; });
        if (updateDimensions) {
            this.updateDeviceDimensions();
        }
    };
    Device.prototype.componentWillUnmount = function () {
        window.removeResizeListener(this._root, this.updateDeviceDimensions);
    };
    Device.prototype.isFullScreen = function () {
        return ((this.props.isMobile &&
            !this.props.isEmbedded &&
            this.props.isFrameless == null) ||
            this.props.isWeb ||
            this.props.isInHandoffMode ||
            this.props.isFrameless);
    };
    Device.prototype.render = function () {
        if (!this.state) {
            // First render
            return null;
        }
        var _a = this.props, frame = _a.frame, orientation = _a.orientation, backgroundColour = _a.backgroundColour, isEmbedded = _a.isEmbedded, isInAnnotationMode = _a.isInAnnotationMode, isInTheExploreView = _a.isInTheExploreView, children = _a.children;
        if (this.isFullScreen()) {
            return children;
        }
        var _b = this.state, width = _b.width, height = _b.height, padding = _b.padding, borderRadius = _b.borderRadius;
        var deviceClass = cx(styles.device, styles[frame.toLowerCase()], styles[[frame.toLowerCase(), orientation].join('-')]);
        var deviceStyle = {
            width: width,
            height: height,
            padding: padding.map(function (p) { return p + "px"; }).join(' '),
        };
        // TODO need to sort out setting the presentation background on
        // Project instead. For now ignoring the background colour so the
        // annotation mode background shows through.
        var wrapperStyle = {
            backgroundColor: isEmbedded || isInAnnotationMode || isInTheExploreView
                ? 'transparent'
                : "#" + backgroundColour,
        };
        return (React.createElement("div", { className: styles.deviceWrapper, style: wrapperStyle },
            React.createElement("div", { className: deviceClass, style: deviceStyle },
                React.createElement("div", { className: styles.deviceScreenBorder, style: { width: width, height: height, borderRadius: borderRadius } }, children))));
    };
    Device.propTypes = {
        orientation: PropTypes.oneOf([Orientation.Portrait, Orientation.Landscape])
            .isRequired,
        frame: PropTypes.string.isRequired,
        dimensions: PropTypes.object.isRequired,
        isMobile: PropTypes.bool.isRequired,
        isEmbedded: PropTypes.bool.isRequired,
        isInTheExploreView: PropTypes.bool.isRequired,
        isInAnnotationMode: PropTypes.bool.isRequired,
        isInHandoffMode: PropTypes.bool.isRequired,
        isWeb: PropTypes.bool.isRequired,
        onScreenResize: PropTypes.func.isRequired,
        backgroundColour: PropTypes.string.isRequired,
        children: PropTypes.node.isRequired,
    };
    Device.defaultProps = {
        onScreenResize: noop,
        isEmbedded: false,
        isFrameless: null,
        backgroundColour: 'transparent',
    };
    return Device;
}(Component));
export default Device;
